import React, { Component } from 'react';
import { Tooltip, Col, Dropdown } from '@platform/base';
import { createOperationIcon, getTopWindow, getGlobalStorage } from '@platform/api';
export default class TipsSearchItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isFocus: false,
            isHover: false,
            inOverlay:false,
        };
        this.hoverTimer = null;
    }

    getOperationLable = operation => {
        const multiLang = this.props.multiLang;
        const OperationOptions = {
            '=': multiLang['page-search-0047'],
            '>': multiLang['page-search-0048'],
            '<': multiLang['page-search-0049'],
            'between': multiLang['page-search-0050'],
            '>=': multiLang['page-search-0051'],
            '<=': multiLang['page-search-0052'],
            '<>': multiLang['page-search-0053'],
            'like': multiLang['page-search-0054'],
            'left like': multiLang['page-search-0055'],
            'right like': multiLang['page-search-0056'],
            'is null': multiLang['page-search-0057'],
            'not like': multiLang['page-search-0084'],
            'is not null': multiLang['page-search-0085'],
            'not between': multiLang['page-search-0102'],
        };
        return OperationOptions[operation];
    }

    createOption = snapshotItem => {
        let oprOption = snapshotItem.operationOptions;
        let opr = snapshotItem.operationSign;
        return oprOption.map(item => {
            return <li className={item.value === opr ? 'opr_selected' : ''} onClick={() => { this.mathSignChange(snapshotItem, item.value, snapshotItem.operationSign); }}>{<span>{this.getOperationLable(item.value)}{item.value === opr ? <i className="iconfont icon_selected icon-liucheng1" /> : null}</span>}<span className="opr_icon">{createOperationIcon(item.value)}</span></li>;
        });
    }

    createOprIcon = operationSign => {
        if (!operationSign) { operationSign = '='; }
        let icon;
        switch (operationSign) {
            case '=':
                icon = <i className="iconfont icon-dengyu" />;
                break;
            case '>':
                icon = <i className="iconfont icon-dayu" />;
                break;
            case '<':
                icon = <i className="iconfont icon-xiaoyu" />;
                break;
            case 'between':
                icon = <i className="iconfont icon-jieyu" />;
                break;
            case 'not between':
                icon = <i className="iconfont icon-buzai" />;
                break;
            case '>=':
                icon = <i className="iconfont icon-dayudengyu" />;
                break;
            case '<=':
                icon = <i className="iconfont icon-xiaoyudengyu" />;
                break;
            case '<>':
                icon = <i className="iconfont icon-budengyu" />;
                break;
            case 'like':
                icon = <i className="iconfont icon-baohan" />;
                break;
            case 'left like':
                icon = <i className="iconfont icon-zuobaohan" />;
                break;
            case 'right like':
                icon = <i className="iconfont icon-youbaohan" />;
                break;
            case 'not like':
                icon = <i className="iconfont icon-bubaohan" />;
                break;
            case 'is null':
                icon = <i className="iconfont icon-weikong" />;
                break;
            case 'is not null':
                icon = <i className="iconfont icon-buweikong" />;
                break;
            default:
                break;
        }
        return icon;
    }

    /* 字段操作符change事件 */
    mathSignChange = (data, val, oldValue) => {
        if (val === oldValue) { return; }
        if ((val !== 'between' && val !== 'not between') && (oldValue === 'between' || oldValue === 'not between')) {
            data.initialvalue.value = '';
            data.initialvalue.display = '';
        } else if ((val === 'between' || val === 'not between') && (oldValue !== 'between' && oldValue !== 'not between')) {
            data.initialvalue.display = [];
            data.initialvalue.value = [];
        }
        data.operationSign = val;
        this.props.setStateEve(() => {
            typeof this.props.onOperateTypeChange === 'function' && this.props.onOperateTypeChange(data.attrcode, val);
        });
    };

    onBlur = e => {
        this.setState({ isFocus: false });
    }
    onFocus = e => {
        this.setState({ isFocus: true });
    }
    onMouseLeave = e => {
        if (this.hoverTimer) { clearTimeout(this.hoverTimer); }
        if (this.state.isHover) {
            this.leaveTimer = setTimeout(() => {
                this.setState({ isHover: false });
            }, 200);
        }
    }
    onMouseEnter = e => {
        if (this.leaveTimer) { clearTimeout(this.leaveTimer); }
        if (!this.state.isHover && this.searchItem && this.searchItem.contains(e.target)) {
            this.hoverTimer = setTimeout(() => {
                this.setState({ isHover: true });
            }, 500);
        }
    }
    onClick = itemtype => {
        let { onBeforeEvent, data } = this.props;
        if (itemtype === 'refer') {
            this.setState({ isFocus: true, isHover: false });
        }
        if (typeof onBeforeEvent === 'function') {
            onBeforeEvent(data.attrcode);
        }
    }
    componentDidMount() {
        this.searchItem && this.searchItem.addEventListener('mouseenter', this.onMouseEnter);
        this.searchItem && this.searchItem.addEventListener('mouseleave', this.onMouseLeave);
    }
    componentWillUnmount() {
        this.searchItem && this.searchItem.removeEventListener('mouseenter', this.onMouseEnter);
        this.searchItem && this.searchItem.removeEventListener('mouseleave', this.onMouseLeave);
    }

    render() {
        let { data, showSearchLable, showLableFlag, tip, fieldTip, showPlaceholder, mustFillInLable, snapshotItem, mustFillIn1, searchChildDom, underlineBorder } = this.props;
        let { isFocus, isHover,inOverlay } = this.state;
        let formStyleConfig = getGlobalStorage('localStorage', "nccForm");
        formStyleConfig = formStyleConfig && JSON.parse(formStyleConfig) || {};
        let onlyBorderBottom = underlineBorder ?? formStyleConfig.formunderlinestyle;
        let fontClass = (window.nccFontSize) || (getTopWindow().nccFontSize) || getGlobalStorage('localStorage', 'nccFontSize') || '';
        let classname = "search_overlay";
        if (data.itemtype === "refer" && data.isMultiSelectedEnabled) {
            classname += ' refer_search_overlay';
        }
        let width = '150px';
        if (fontClass) {
            switch (fontClass) {
                case 'large':
                    width = '185px';
                    break;
                case 'medium':
                    width = '168px';
                    break;
                default:
                    break;
            }
        }
        return (<div key={data.attrcode}>
            {showSearchLable && showLableFlag && <div className="searchTtem-area">
                <span className="searchItem-lable" >{mustFillInLable}{data.label}</span>
                {Array.isArray(snapshotItem.operationOptions) && snapshotItem.operationOptions.length > 1 ? <Dropdown
                    trigger='click'
                    placement="bottomLeft"
                    overlayClassName='opr_dropdown'
                    overlay={(
                        <ul className="menu_items opr_menu" style={{ width: width }}>
                            {this.createOption(snapshotItem)}
                        </ul>
                    )}
                >
                    <span className="oprOptionLable oprOptionLable-hover"> {createOperationIcon(snapshotItem.operationSign)} <i className="iconfont oprOptionIcon icon-hangcaozuoxiala1" /></span>
                </Dropdown> : <span className="oprOptionLable no-select"> {createOperationIcon(snapshotItem.operationSign)}</span>}
            </div>}
            <Tooltip
                inverse
                className={classname}
                overlay={<div
                onMouseEnter={()=>{
                    this.setState({inOverlay:true})
                }}
                onMouseLeave={()=>{
                    this.setState({inOverlay:false})
                }}
                >{tip}</div>}
                placement="top"
                delayHide={300}
                // getPopupContainer={() => { return this.searchItem }}
                visible={(fieldTip && showPlaceholder && isHover && !isFocus)||inOverlay}
            >
                <div className={`condition-contant ${onlyBorderBottom ? 'only-border-bottom-style' : ''}`}
                    ref={dom => {
                        this.searchItem = dom;
                    }}
                    onBlur={this.onBlur}
                    onFocus={this.onFocus}
                    onClick={this.onClick.bind(this, data.itemtype)}>
                    {mustFillIn1}
                    {searchChildDom}
                </div>
            </Tooltip>
        </div >);
    }
}